import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

/**
 * Refresh token DTO Schema for token refresh/logout operations.
 * refreshToken is optional to support cookie-based flows where the
 * httpOnly cookie provides the token instead of the request body.
 */
export const RefreshTokenDtoSchema = z
    .object({
        /** JWT refresh token (optional — can also be provided via httpOnly cookie) */
        refreshToken: z.string().min(1, 'Refresh token must not be empty').optional(),
    })
    .strict();

/**
 * Refresh token DTO for token refresh/logout operations.
 * refreshToken may be absent when using httpOnly cookie-based auth.
 */
export class RefreshTokenDto extends FromSchema(RefreshTokenDtoSchema) {
    refreshToken?: string;
}
